import { parse, stringify } from 'query-string';
import useStewardshipFilter from '../../projects/useStewardshipFilter';
import REQUIRED_FIELDS_PUBLIC from '../../projects/REQUIRED_FIELDS_PUBLIC';
import { useConnect } from '../../../../hooks/@lore/query-connect';

export default function useQuery(props) {
  const { location, PAGE_SIZE = 10, extra = {} } = props;

  const stewardshipFilter = useStewardshipFilter();

  return useConnect('project.find', {
    where: {
      eager: {
        $where: {
          $and: REQUIRED_FIELDS_PUBLIC.$and,
          $or: stewardshipFilter,
          ...extra
        }
      }
    },
    pagination: {
      page: parse(location.search).page || '1',
      pageSize: PAGE_SIZE,
      order: 'createdAt desc'
    }
  }, {
    keepPreviousData: true
  });
}
